import { render, staticRenderFns } from "./CloseQuerylogsForm.vue?vue&type=template&id=110d9bcf&"
import script from "./CloseQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./CloseQuerylogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports